// 🔧 organization_statistics.js
// ✅ Purpose: Displays Organization summary statistics
// ✅ Features:
// - Uniform statistics cards
// - Responsive Bootstrap layout
// - Future-ready for live Organization Engine statistics
//
// ✅ Notes:
// - Presentation only
// - Currently reads values from the organization document
// - Later versions will consume Organization Engine statistics

import React from "react";

const valueOrZero = (value) => {

  return value ?? 0;

};

const OrganizationStatistics = ({
  organization,
}) => {

  return (

    <div className="row g-3">

      <div className="col-md-3">

        <div className="card h-100 shadow-sm">

          <div className="card-body">

            <div className="small text-muted">

              Events

            </div>

            <div className="fs-4 fw-bold">

              {valueOrZero(
                organization.eventCount
              )}

            </div>

          </div>

        </div>

      </div>

      <div className="col-md-3">

        <div className="card h-100 shadow-sm">

          <div className="card-body">

            <div className="small text-muted">

              Members

            </div>

            <div className="fs-4 fw-bold">

              {valueOrZero(
                organization.memberCount
              )}

            </div>

          </div>

        </div>

      </div>

      <div className="col-md-3">

        <div className="card h-100 shadow-sm">

          <div className="card-body">

            <div className="small text-muted">

              Community

            </div>

            <div className="fs-4 fw-bold">

              {valueOrZero(
                organization.communityCount
              )}

            </div>

          </div>

        </div>

      </div>

      <div className="col-md-3">

        <div className="card h-100 shadow-sm">

          <div className="card-body">

            <div className="small text-muted">

              Health Score

            </div>

            <div
              className={`fs-4 fw-bold ${
                organization.healthScore >= 90
                  ? "text-success"
                  : organization.healthScore >= 70
                    ? "text-warning"
                    : "text-danger"
              }`}
            >

              {valueOrZero(
                organization.healthScore
              )}%

            </div>

          </div>

        </div>

      </div>

      <div className="row mt-3">

        <div className="col-12">

          <div className="alert alert-light border mb-0">

            <div className="d-flex flex-wrap gap-4">

              <div>

                <strong>Status:</strong>{" "}
                {organization.healthStatus}

              </div>

              <div>

                <strong>Warnings:</strong>{" "}
                {organization.warningCount}

              </div>

              <div>

                <strong>Errors:</strong>{" "}
                {organization.errorCount}

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default OrganizationStatistics;